import React from 'react';
import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const ValveWidget = ({
  arrowsColor,
  borderColor,
  backgroundColor,
  width,
  height,
  ...rest
}: {
  arrowsColor?: string;
  borderColor?: string;
  backgroundColor?: string;
  width?: number;
  height?: number;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentArrowsColor = arrowsColor ?? token.colorPrimary;
  const currentBorderColor = borderColor ?? token.colorBorder;
  const currentBackgroundColor = backgroundColor ?? token.colorBgContainer;
  return (
    <svg width={width} height={height} viewBox="0 0 48 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M4 31H2C0.895431 31 0 30.1046 0 29L0 21C0 19.8954 0.895431 19 2 19H4L4 31Z" fill={token.colorBorder} />
      <path
        d="M6 14.6077L24 4.21538L42 14.6077V35.3923L24 45.7846L6 35.3923V14.6077Z"
        fill={currentBackgroundColor}
        stroke={currentBorderColor}
        strokeWidth="4"
      />
      <path d="M44 19H46C47.1046 19 48 19.8954 48 21V29C48 30.1046 47.1046 31 46 31H44V19Z" fill={token.colorBorder} />
      <path
        d="M24.0672 25.4422L16.5672 32.9422C16.4798 33.0297 16.3684 33.0893 16.2471 33.1135C16.1258 33.1376 16 33.1252 15.8858 33.0779C15.7715 33.0305 15.6738 32.9504 15.6052 32.8475C15.5365 32.7446 15.4999 32.6237 15.5 32.5V29.375H9.25C8.91848 29.375 8.60054 29.2433 8.36612 29.0089C8.1317 28.7745 8 28.4565 8 28.125V21.875C8 21.5435 8.1317 21.2255 8.36612 20.9911C8.60054 20.7567 8.91848 20.625 9.25 20.625H15.5V17.5C15.4999 17.3763 15.5365 17.2554 15.6052 17.1525C15.6738 17.0496 15.7715 16.9695 15.8858 16.9221C16 16.8748 16.1258 16.8624 16.2471 16.8865C16.3684 16.9107 16.4798 16.9703 16.5672 17.0578L24.0672 24.5578C24.1253 24.6159 24.1714 24.6848 24.2029 24.7607C24.2343 24.8365 24.2505 24.9179 24.2505 25C24.2505 25.0821 24.2343 25.1635 24.2029 25.2393C24.1714 25.3152 24.1253 25.3841 24.0672 25.4422Z"
        fill={currentArrowsColor}
      />
      <path
        d="M40 21.875V28.125C40 28.4565 39.8683 28.7745 39.6339 29.0089C39.3995 29.2433 39.0815 29.375 38.75 29.375H32.5V32.5C32.5001 32.6237 32.4635 32.7446 32.3948 32.8475C32.3262 32.9504 32.2285 33.0305 32.1142 33.0779C32 33.1252 31.8742 33.1376 31.7529 33.1135C31.6316 33.0893 31.5202 33.0297 31.4328 32.9422L23.9328 25.4422C23.8747 25.3841 23.8286 25.3152 23.7972 25.2393C23.7657 25.1635 23.7495 25.0821 23.7495 25C23.7495 24.9179 23.7657 24.8365 23.7972 24.7607C23.8286 24.6848 23.8747 24.6159 23.9328 24.5578L31.4328 17.0578C31.5202 16.9703 31.6316 16.9107 31.7529 16.8865C31.8742 16.8624 32 16.8748 32.1142 16.9221C32.2285 16.9695 32.3262 17.0496 32.3948 17.1525C32.4635 17.2554 32.5001 17.3763 32.5 17.5V20.625H38.75C39.0815 20.625 39.3995 20.7567 39.6339 20.9911C39.8683 21.2255 40 21.5435 40 21.875Z"
        fill={currentArrowsColor}
      />
    </svg>
  );
};

export default ValveWidget;
